<template>
  <aside class="fixed right-[2vw] bottom-[2vw] max-lg:hidden z-10">
    <!-- v-if="$route.path && $route.path.includes('/mall')" -->
    <button class="chatbot block relative mb-2" @click="toggleChat">
      <span class="chatbot-banner" :class="{ 'animate-initial': showInitialAnim }"> 문의사항이 있으신가요? 챗봇으로 상담하세요. </span>
      <img src="/assets/image/ai-chat-icon.png" alt="챗봇 상담" class="relative z-10" />
    </button>

    <!-- <button type="button" @click="scrollToTop">
      <svg
        width="45"
        height="45"
        viewBox="0 0 45 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="0.5"
          y="0.5"
          width="44"
          height="44"
          rx="9.5"
          fill="white"
          stroke="#0C3388"
        />
        <path
          d="M24.0927 17.7916V32.5384H21.6005V17.7916L14.9163 24.2903L13.1543 22.5772L22.8466 13.1538L32.5389 22.5772L30.7769 24.2903L24.0927 17.7916Z"
          fill="#0C3388"
        />
      </svg>
    </button> -->
    <a href="https://pf.kakao.com/_YqHmu/chat" target="_blank">
      <svg width="45" height="45" viewBox="0 0 45 45" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="45" height="45" rx="10" fill="#FFF100" />
        <path
          d="M22.845 11.5176C29.2186 11.5176 34.3845 15.8192 34.3845 21.127C34.3845 26.4335 29.2186 30.7351 22.8461 30.7351C22.2115 30.7355 21.5776 30.6923 20.9483 30.606L16.1043 33.9907C15.5538 34.3018 15.3593 34.2678 15.5856 33.5058L16.5659 29.1878C13.401 27.4737 11.3076 24.5034 11.3076 21.127C11.3076 15.8204 16.4725 11.5176 22.8461 11.5176H22.845Z"
          fill="#1B1D21"
        />
      </svg>
    </a>

    <!-- AI 검색 iframe 레이어 (450x760) -->
    <div v-if="isChatOpen" class="fixed right-[calc(2vw+3.5rem)] bottom-[2vw] z-30 bg-white rounded-xl shadow-2xl border border-neutral-200 overflow-hidden" style="width: 450px; height: 600px">
      <!-- 닫기 버튼 -->
      <div class="flex items-center justify-end px-3 py-2 border-b border-neutral-200 bg-neutral-50">
        <button type="button" class="text-neutral-500 hover:text-neutral-800" @click="toggleChat" aria-label="닫기">✕</button>
      </div>
      <iframe title="AI 검색" src="/mall/ai-search" style="width: 100%; height: calc(100% - 41px); border: 0"></iframe>
    </div>
  </aside>
</template>

<script>
export default {
  // 한국어 주석: 버튼 클릭 시 AI 검색 페이지를 아이프레임으로 띄우는 레이어를 토글합니다.
  data() {
    return {
      isChatOpen: false, // 한국어 주석: 아이프레임 레이어 열림 상태
      showInitialAnim: false, // 한국어 주석: 최초 1회 배너 애니메이션 실행 여부
    };
  },
  mounted() {
    // 한국어 주석: 세션 내 최초 1회만 배너 애니메이션을 실행합니다.
    const alreadyShown = sessionStorage.getItem("chatbotBannerShown") === "1";
    if (!alreadyShown) {
      this.showInitialAnim = true;
      sessionStorage.setItem("chatbotBannerShown", "1");
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    toggleChat() {
      this.isChatOpen = !this.isChatOpen;
    },
  },
};
</script>

<style scoped>
button,
a {
  filter: drop-shadow(0px 3px 3px #00000020);
}

.chatbot-banner {
  position: absolute;
  right: 0;
  display: flex;
  width: 0;
  height: 45px;
  align-items: center;
  background: #0c3388;
  color: #fff;
  border-radius: 12px;
  opacity: 0;
  font-size: 0.875rem;
  padding-left: 0.75rem;
  white-space: pre;
  transition: width 0.5s, opacity 0.5s;
  overflow: hidden;
}

.chatbot:hover .chatbot-banner {
  width: 322px;
  opacity: 1;
}
</style>
